module.exports = __webpack_public_path__ + "media/images/play-13145fc123ea28884e130ee95a557631.png";